<eb-label
    class="new-tag__tag"
    size="sm"
>
    {{ 'common.new_universal' | transloco | uppercase }}
</eb-label>
